import { Container } from "@mui/system";
import React from "react";
import { useParams } from "react-router-dom";
import { useState, useRef, useEffect, useReducer } from "react";
import { Forms } from "../../shared/forms/forms";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {
  Tabs,
  Tab,
  Box,
  Button,
  MenuItem,
  IconButton,
  Input,
  InputLabel,
  Tooltip,
  FormControl,
  SelectChangeEvent 
} from "@mui/material";
import { styled } from "@mui/system";
import {
  getTicketById,
  updateTicket,
  updateTicketHours,
  updateTicketSpecification,
  createNewPayroll,
  deletePayroll,
  updatePayroll,
  ticketSign,
  resetTicketSign,
  downloadTicket,
  getPreviewTicket,
  customerTicketSign,
  getPayrollDetails,
  sendToCustomer,
  updateWellRecord,
  addWellRecord,
  deleteWellRecord,
  addSwabCup,
  updateSwabCup,
  updateTicketOther,
  deleteSwabCup,
  getAllSpecialSpecifications
} from "../../services/tickets-service";
import { getEquipmentByCategory } from "../../services/equipment-service";
import { getCustomers, getCustomerById } from "../../services/customer-service";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Select,
  
} from "@mui/material";
import { getAllEmployees } from "../../services/employee-service";
import { getEmployees } from "../../services/employee-service";
import { SignatureModal } from "../../shared/signature/signature";
import { getProfile } from "../../services/profile-service";
import Divider from "@mui/material/Divider";
import ModalComponent from "../../shared/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { uploadFile } from "../../services/http-service";
import { formatDateTime, toCurrencyNumber } from "../../utils/date-functions";
import { LoadingComponent } from "../../services/loading-service";
import dayjs from "dayjs";
import {useAuth} from "../../hooks/useAuth";
import { downloadDoc } from "../../utils/download-file";
import { createNote, deleteNote, updateNote } from "../../services/notes-service";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import "bootstrap/dist/css/bootstrap.min.css";
import {  Table as RBTable, Form, Card } from "react-bootstrap";
import { updateJobStatus } from "../../services/tickets-service";
import styles from '../GasPumpRecord/style.module.css';
import { set } from "date-fns";
let utc = require('dayjs/plugin/utc')
dayjs.extend(utc);

const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: "16px",
  color: "black",
  fontWeight: "600",
}));

export const EditTicket = () => {
  const { id } = useParams();
  const { role } = useAuth();

  const payrollOriginalRigRef = useRef(0)
  const handlePayrollFieldChange = name => e => {
    const val = parseFloat(e.target.value) || 0
    setPayrollEditFields(fields =>
      fields.map(fld => {
        if (fld.name === name) {
          return { ...fld, value: val }
        }
        // whenever yardHours changes, update rigHours
        if (name === 'yardHours' && fld.name === 'rigHours') {
          const newRig = parseFloat(
            (payrollOriginalRigRef.current - val).toFixed(2)
          ) || 0
          return { ...fld, value: newRig }
        }
        return fld
      })
    )
  }

  const [selectedTab, setSelectedTab] = useState(0);
  const [ticketBasicInfoFields, setTicketBasicInfoFields] = useState([]);
  const [ticketHourlyFields, setTicketHourlyFields] = useState([]);
  // const [wellOtherField, setWellOtherField] = useState([]);
  const [wellOtherField, setWellOtherField] = useState([{
    label:    "Other",
    type:     "textarea",
    name:     "otherText",
    value:    "",
    disabled: true,
    size:     12,
  }]);
  const [chargesDataLeft, setChargesDataLeft] = useState([]);
  const [chargesDataRight, setChargesDataRight] = useState([]);
  const [allCharges, setAllCharges] = useState([]);
  const [chargesDataWell, setChargesDataWell] = useState([]);
  const [swabData, setSwabData] = useState([]);

  const [payrollData, setPayrollData] = useState([]);
  const [wellRecord, setWellRecord] = useState([]);
  const [hasUserSignature, setHasUserSignature] = useState(false);
  const [hasCustomerSignature, setHasCustomerSignature] = useState(false);
  const [showTimeErrorMessage, setShowTimeErrorMessage] = useState(false);
  const [chargeToUpdate, setChargeToUpdate] = useState(null);

  const [wellToUpdate, setWellToUpdate] = useState(null);
  const [swabToUpdate, setSwabToUpdate] = useState(null);

  const [ticketData, setTicketData] = useState(null);
  const [jobComplete, setJobComplete] = useState(null);
  const [headerCell, setHeaderCell] = useState("");
  const [canUpdateTicket, setCanUpdateTicket] = useState(null);
  const [ticketType, setTicketType] = useState("");

  const [ticketTotal, setTicketTotal] = useState(0);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [isYard, setIsYard] = useState(false);
  const [isRoustabout, setIsRoustabout] = useState(false);

  const [customerId, setCustomerId] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [locations, setLocations] = useState([]);

  const [allEmployees, setAllEmployees] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const [createWellModalOpened, setCreateWellModalOpened] = useState(false);
  const [createSwabModalOpened, setCreateSwabModalOpened] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState("");

  const [createPayrollModalOpened, setCreatePayrollModalOpened] = useState(false);
  const [showPayrollEntryName, setShowPayrollEntryName] = useState(false);
  const [payrollEntryName, setPayrollEntryName] = useState("");
  const [deletePayrollModalOpened, setDeletePayrollModalOpened] = useState(false);
  const [currentPayrollIndex, setCurrentPayrollIndex] = useState("");
  const [currentPayrollName, setCurrentPayrolllName] = useState("");
  const [isEditingPayroll, setIsEditingPayroll] = useState(false);
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [editPayrollModalOpened, setEditPayrollModalOpened] = useState(false);
  const [notePayrollModalOpened, setNotePayrollModalOpened] = useState(false);
  const [deleteNoteModalOpened, setDeleteNoteModalOpened] =  useState(false);
  const [payrollEditFields, setPayrollEditFields] = useState([]);
  const [payrollNoteFields, setPayrollNoteFields] = useState([]);
  const [ShowPumpNumber, setShowPumpNumber] = useState(false);
  const [rodSubsSize, setRodSubsSize] = useState(false);

  const [employeeId, setEmployeeId] = useState("");
  const [payrollId, setPayrollId] = useState("");
  const [noteId, setNoteId] = useState("");
  const [noteTicketId, setNoteTicketId] = useState("")
  const [htmlPreviewModalOpened, sethtmlPreviewModalOpened] = useState("");
  
  const [previewTicketHtml, setPreviewTicketHtml] = useState("");
  const [signatureModalOpened, setSignatureModalOpened] = useState(false);
  const [isEmployeeSignature, setIsEmployeeSignature] = useState(true);
  const [resetSignaturesModalOpened, setResetSignaturesModalOpened] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [currentNoteColor, setCurrentNoteColor] = useState("red");
  const [uploadTicketModal, setUploadTicketModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [disableAddCharges, setDisableAddCharges] = useState(false);

  const [rigOverrideDialogOpen, setRigOverrideDialogOpen] = useState(false);
  const rigDraftRef = useRef(null);   // holds the edited Rig row until user confirms

  const isAdmin = role && role === "admin";
  const isCustomer = role && role === "customer";
  const primaryColor = "#192cd2";
  
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const navigate = useNavigate();
  const ref = useRef();

  async function handleJobCompleteChange(value) {
    setJobComplete(value);
    try {
      await updateJobStatus({ ticketId: id, isJobComplete: value });
    } catch {
      alert("Couldn't save job status");
    }
  }

  // Region - Data Requests

  // Getting all ticket data and setting the form
  const getTicketsData = () => {
    setTicketData(null);
    setCanUpdateTicket(null);
    getTicketById(id).then((data) => {
      setTicketData(data);
      setTicketType(data.ticketType);
      setCanUpdateTicket(!data.hasEmployeeSignature && !isCustomer);
      setMainLoading(false);
    });
  };

  const setTicketInfo = () => {
    setTicketBasicInfo(ticketData);
    setTicketHourlyData(ticketData);
    setWellChargeOther(ticketData)
    if(ticketType === "Well"){
      setAllCharges(ticketData.allTicketSpecifications);
      setChargesDataWell(ticketData.ticketSpecificationsData);
      setWellRecord(ticketData.wellRecord);
      setSwabData(ticketData.swabCups)
    }
      setChargesDataLeft(ticketData.ticketSpecificationsLeft);
      setChargesDataRight(ticketData.ticketSpecificationsRight);
      setPayrollData(ticketData.payrollData);
      setHasUserSignature(ticketData.hasEmployeeSignature);
      setHasCustomerSignature(ticketData.hasCustomerSignature);
      setCustomerId(ticketData.customerId);
      setServiceTypes(ticketData.serviceTypes);
      setTicketTotal(ticketData.total);
      return
  };

  // Get list of locations for customer
  const getLocationsList = (customerId) => {
    if (!customerId) {
      return;
    }
    setMainLoading(true);
    getCustomerById(customerId).then((res) => {
      const currentLocations = res.locations.map((item) => ({
        value: item.id,
        label: item.displayName,
      }));
      setLocations(currentLocations || []);
      setTicketBasicInfo(ticketData, currentLocations);
      setMainLoading(false);
    });
  };

  // EndRegion - Data Requests

  // Region - UseEffects

  // Initial get requests
  useEffect(() => {
    // Getting all rigs
    setMainLoading(true);
    getEquipmentByCategory(1).then((resData) => {
      setEquipment(resData);
      // Getting all customers
      getCustomers().then((resData) => {
        setCustomers(resData);
        // Getting all employees
        getEmployees(true).then((resData) => {
          setAllEmployees(resData);
          getTicketsData();
        });
      });
    });
  }, []);

  useEffect(() => {
    if (ticketData == null) {
      return;
    }
    if (ticketData) {
      // ticketData.isJobComplete is a boolean or null
      setJobComplete(ticketData.isJobComplete ?? null);
    }
    setIsYard(ticketData.serviceTypes.includes("Yard"));
    setIsRoustabout(ticketData.serviceTypes.includes("Roustabout"));
  }, [ticketData]);

  // Get locations for customer on customer id change
  useEffect(() => {
    getLocationsList(customerId);
  }, [customerId]);

  useEffect(() => {
    if (ticketData == null) {
      return;
    }
    setTicketInfo();
  }, [canUpdateTicket, isYard]);


  // EndRegion - UseEffects

  // Region - UI Helpers & Definitions

  // Equipment select items
  const selectEquipment = equipment.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  // Customer select items
  const selectCustomer = customers.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  // Employee select items
  const selectEmployee = employeeList.map((item) => ({
    value: item.id,
    label: item.firstName + " " + item.lastName,
  }));

  // Ticket update button
  const ticketUpdateButton = {
    buttonName: "Update"
  };

  // Columns for charges section
  const chargesColumn = [
    { accessorKey: "charge", header: "Name" },
    { accessorKey: "uoM", header: "uoM" },
    { accessorKey: "rate", header: "Rate" },
    { accessorKey: "quantity", header: "Quantity" },
    { accessorKey: "total", header: "Total", isTotal: true },
  ];

 // Columns for well record section
  const wellRecordColumn = [
    { accessorKey: "wellRecord", header: "Name", editable: "false", span : "2"},
    { accessorKey: "pulled", header: "Pulled", type: 'number', editable: "true", span : "1"},
    { accessorKey: "ran", header: "Ran", type: 'number', editable: "true",span : "1" },
    { accessorKey: "size", header: "Size", type: 'number', editable: "true",span : "4"},
  ];

   // Columns for swab charges section
   const swabChargesColumn = [
    { accessorKey: "numberSwab", header: "No." },
    { accessorKey: "size", header: "Size" },
    { accessorKey: "description", header: "Description" },
    { accessorKey: "amount", header: "Amount" },
  ];

  const basicFormRef  = useRef();
const hoursFormRef  = useRef();


  // EndRegion - UI Helpers & Definitions

  // Region - Fields

  // Base ticket info fields
  const setTicketBasicInfo = (ticketData, currentLocations = null) => {
    const basicTicketFields = [
      {
        label: "Ticket ID",
        type: "text",
        name: "ticketId",
        readOnly: !isAdmin,
        disabled: !canUpdateTicket,
        required: true,
        value: ticketData.ticketId,
        size: 3,
        onChange: (_evt, value) => {
          basicFormRef.current.submit();
        },
      }, 
      {
        label: "Customer",
        type: "autocomplete",
        name: "customerId",
        required: false,
        value: ticketData.customerId,
        disabled: !canUpdateTicket || isYard,
        selectOptions: isYard ? [''] : selectCustomer,
        onChange: (customerId) => {
          setCustomerId(customerId);
          basicFormRef.current.submit();
        },
        size: 3,
        
      },
      {
        label: "Customer Location",
        type: "select",
        name: "locationId",
        disabled: !canUpdateTicket || isYard,
        required: false,
        value: ticketData.locationId,
        selectOptions: isYard ? [''] : currentLocations || locations,
        size: 3,
        onChange: (_evt, value) => {
          basicFormRef.current.submit();
        },
      },
      {
        label: "Email ticket to",
        type: "text",
        name: "sendEmailTo",
        disabled: !canUpdateTicket || isYard,
        required: false,
        value: ticketData.sendEmailTo,
        size: 3,
              // fire immediately when they pick a location
      onChange: (_evt, value) => {
        basicFormRef.current.submit();
      },
      },
      {
       
        label: "Service Type",
        type: "multiSelect",
        name: "serviceTypes",
        disabled: !canUpdateTicket,
        required: true,
        value: ticketData.serviceTypes,
        selectOptions: [
          {
            label: "Rods and Tubing",
            value: "RodsAndTubing",
            disabled: false
          },
          {
            label: "Workover",
            value: "Workover",
            disabled: false
          },
          {
            label: "P&A",
            value: "PAndA",
            disabled: false
          },
          {
            label: "Completion",
            value: "Completion",
            disabled: false
          },
          {
            label: "Stand By",
            value: "StandBy",
            disabled: false
          },
          {
            label: "Yard",
            value: "Yard",
            disabled: false
          },
          {
            label: "Roustabout",
            value: "Roustabout",
            disabled: false
          },
        ],
        size: 4,
        onChange: (event) => {
          setIsYard(event.includes("Yard"));
          setIsRoustabout(event.includes("Roustabout"));
          basicFormRef.current.submit();
        }
      },
      {
        label: "Equipment Name",
        type: "select",
        name: "equipmentId",
        disabled: !canUpdateTicket,
        required: true,
        value: ticketData.equipmentId,
        selectOptions: selectEquipment,
        size: 4,
        onChange: (_evt, value) => {
          basicFormRef.current.submit();
        },
      },
      {
        label: "Execution Date",
        type: "datetime",
        name: "executionDate",
        disabled: !canUpdateTicket,
        required: true,
        value: ticketData.executionDate,
        size: 4,
        onChange: (newDate) => {
          basicFormRef.current.submit();
        },
      }
    ];

    setTicketBasicInfoFields(basicTicketFields);
  };

  // Region - UI Handlers

  // Handle Tab change
  const onTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Handle basic ticket info edited
  const onBasicTicketInfoEdited = (data) => {
    data.id = id;
    data.customerLocationId = data.locationId;
    if (isYard) {
      data.customerId = null;
      data.customerLocationId = null;
    } else if (data.customerId === "" || data.customerLocationId === "" || data.customerId === null || data.customerLocationId === null) {
      return;
    }
    setMainLoading(true);
    updateTicket(data).then(() => {
      getTicketsData();
    });
  };

  // Handle update for well other text
  const onWellOtherEdited = (data) => {
    data.ticketId = id;

    setMainLoading(true);
    updateTicketOther(data).then(() => {
      getTicketsData()
      getPayrollDetails(ticketData.id).then((payrollDetails) => {
        setPayrollData(payrollDetails);
      })
    });
  };


  // Handle update for ticket hours
  const onTicketHoursEdited = (data) => {
    data.ticketId = id;

    if (data.endTime <= data.startTime) {
      setShowTimeErrorMessage(true);
      return;
    }
    setMainLoading(true);
    updateTicketHours(data).then(() => {
      getTicketsData()
      getPayrollDetails(ticketData.id).then((payrollDetails) => {
        setPayrollData(payrollDetails);
      })
    });
  };

  // Handle Charge Updates
  const onChargeUpdate = (index, event, prop, isFloat, side) => {
    var updatedValue = event.target.value;
    if (isFloat) {
      if (!updatedValue.endsWith('.')) {
        updatedValue = parseFloat(updatedValue);
      }
      if (isNaN(updatedValue)) {
        updatedValue = 0;
      }
    }
    if (side === 'left') {
      chargesDataLeft[index][prop] = updatedValue;
    } else {
      chargesDataRight[index][prop] = updatedValue;
    }
    forceUpdate();
  }

  // Copy current row on focus in
  const onChargeRowFocusIn = (index, side) => {
    if (!canUpdateTicket) {
      return;
    }
    const charge = side === 'left' ? chargesDataLeft[index] : chargesDataRight[index];
    const chargeToUpdate = {
      rate: charge.rate,
      quantity: charge.quantity,
      uom: charge.uoM
    };
    setChargeToUpdate(chargeToUpdate);
  };

  const onQuantityBlur = (index, side) => {
    if (!canUpdateTicket) return;
  
    const row =
      side === 'left' ? chargesDataLeft[index] : chargesDataRight[index];
  
    // nothing to compare with
    if (!chargeToUpdate) return;
  
    // ➊ Confirmation for Rig qty override
    if (
      row.charge === 'Rig' &&
      row.quantity !== chargeToUpdate.quantity
    ) {
      rigDraftRef.current = row;
      setRigOverrideDialogOpen(true);
      setChargeToUpdate(null);
      return;
    }
  
    // ➋ Normal save path
    if (
      row.rate     !== chargeToUpdate.rate ||
      row.quantity !== chargeToUpdate.quantity ||
      row.uoM      !== chargeToUpdate.uom
    ) {
      updateTicketSpecification(row).then(resData => {
        setTicketTotal(resData.ticketTotal);
        getPayrollDetails(ticketData.id).then(setPayrollData);
      });
    }
    setChargeToUpdate(null);
  };

  
  // Handle Charges update on focus out
  const onChargeRowFocusOut = (index, side) => {
    if (!canUpdateTicket) {
      return;
    }

    const chargeToCheck =
    side === 'left' ? chargesDataLeft[index] : chargesDataRight[index];

  /* 1️⃣ EXIT EARLY WHEN chargeToUpdate IS NULL
        (means the cell-blur handler already ran) */
  if (!chargeToUpdate) return;

    // If the Rig quantity has changed, ask for confirmation first
    if (
      chargeToCheck.charge === 'Rig' &&
      chargeToUpdate &&                        // we have an original copy
      chargeToCheck.quantity !== chargeToUpdate.quantity
    ) {
      rigDraftRef.current = chargeToCheck;     // remember the pending change
      setRigOverrideDialogOpen(true);          // open the popup
      setChargeToUpdate(null);                 // reset tracker
      return;                                  // stop here, do not save yet
    }
    if (chargeToCheck.rate !== chargeToUpdate.rate || chargeToCheck.quantity !== chargeToUpdate.quantity || chargeToCheck.uoM !== chargeToUpdate.uom) {
      updateTicketSpecification(chargeToCheck).then((resData) => {
        setTicketTotal(resData.ticketTotal);
        getPayrollDetails(ticketData.id).then((payrollDetails) => {
          setPayrollData(payrollDetails);
        })
      });
    }
    setChargeToUpdate(null);
  };

  // Handle Well Updates
  const onWellUpdate = (index, event, prop, isFloat) => {
    var updatedValue = event.target.value;
    if (isFloat) {
      if (!updatedValue.endsWith('.')) {
        updatedValue = parseFloat(updatedValue);
      }
      if (isNaN(updatedValue)) {
        updatedValue = 0;
      }
    }
    wellRecord[index][prop] = updatedValue;
    forceUpdate();
  }

  // Copy current row on focus in
  const onWellRowFocusIn = (index) => {
    if (!canUpdateTicket) {
      return;
    }
    const record = wellRecord[index];
    const recordToUpdate = {
      id : record.id,
      fieldTicketId : record.fieldTicketId,
      wellRecordType: record.wellRecordType,
      pump_Number: record.pump_Number,
      pulled: record.pulled,
      ran: record.ran,
      sizeW: record.sizeW,
      sizeL: record.sizeL,
      sizeH: record.sizeH,
    };
    setWellToUpdate(recordToUpdate);
  };

  // Handle Swab Record update on focus out
  const onWellRowFocusOut = (index) => {
    if (!canUpdateTicket) {
      return;
    }

    const recordToCheck = wellRecord[index];
    if(recordToCheck.pump_Number != wellToUpdate.pump_Number || recordToCheck.pulled != wellToUpdate.pulled || recordToCheck.ran != wellToUpdate.ran || recordToCheck.sizeW != wellToUpdate.sizeW || recordToCheck.sizeL != wellToUpdate.sizeL || recordToCheck.sizeH != wellToUpdate.sizeH){
      updateWellRecord(recordToCheck).then(() => getTicketsData())
  }
    setWellToUpdate(null);
  };

  const onWellDelete = (index) => {
    const record = wellRecord[index];
    const recordToDelete = {
      id : record.id,
      fieldTicketId : record.fieldTicketId,
      wellRecordType: record.wellRecordType,
      pump_Number: record.pump_Number,
      pulled: record.pulled,
      ran: record.ran,
      sizeW: record.sizeW,
      sizeL: record.sizeL,
      sizeH: record.sizeH,
    };
    
    deleteWellRecord(recordToDelete).then(() => getTicketsData());
  }

  const onSwabDelete = (index) => {
    const record = swabData[index];
    const recordToDelete = {
      id : record.id,
      fieldTicketId : record.fieldTicketId,
      Number: record.number,
      Size: record.size,
      Description: record.description,
      Amount: record.amount,
    };
    deleteSwabCup(recordToDelete).then(() => getTicketsData());
  }
  // Handle Swab Updates
  const onSwabUpdate = (index, event, prop, isFloat) => {
    var updatedValue = event.target.value;
    if (isFloat) {
      if (!updatedValue.endsWith('.')) {
        updatedValue = parseFloat(updatedValue);
      }
      if (isNaN(updatedValue)) {
        updatedValue = 0;
      }
    }
    swabData[index][prop] = updatedValue;
    forceUpdate();
  }

  // Copy current row on focus in
  const onSwabRowFocusIn = (index) => {
    if (!canUpdateTicket) {
      return;
    }
    const record = swabData[index];
    const recordToUpdate = {
      number: record.number,
      size: record.size,
      description: record.description,
      amount: record.amount,
    };
    setSwabToUpdate(recordToUpdate);
  };

  // Handle Swab Record update on focus out
  const onSwabRowFocusOut = (index) => {
    if (!canUpdateTicket) {
      return;
    }

    const recordToCheck = swabData[index];
    if(recordToCheck.number != swabToUpdate.number || recordToCheck.description != swabToUpdate.description || recordToCheck.amount != swabToUpdate.amount || recordToCheck.size != swabToUpdate.size){
    updateSwabCup(recordToCheck).then(() => getTicketsData());
  }
    setSwabToUpdate(null);
  };

  //Handle charge updates for well
  const onWellChargeUpdate = (index, event, prop, isFloat) => {
    var updatedValue = event.target.value;
    if (isFloat) {
      if (!updatedValue.endsWith('.')) {
        updatedValue = parseFloat(updatedValue);
      }
      if (isNaN(updatedValue)) {
        updatedValue = 0;
      }
    }
    chargesDataWell[index][prop] = updatedValue;
    forceUpdate();
  }

  // Copy current row on focus in
  const onWellChargeRowFocusIn = (index, side) => {
    if (!canUpdateTicket) {
      return;
    }
    const charge = chargesDataWell[index];
    const chargeToUpdate = {
      rate: charge.rate,
      quantity: charge.quantity,
      uom: charge.uoM
    };
    setChargeToUpdate(chargeToUpdate);
  };

  // Handle Charges update on focus out
  const onWellChargeRowFocusOut = (index, side) => {
    if (!canUpdateTicket) {
      return;
    }

    const chargeToCheck = chargesDataWell[index];
    if (chargeToCheck.rate !== chargeToUpdate.rate || chargeToCheck.quantity !== chargeToUpdate.quantity || chargeToCheck.uoM !== chargeToUpdate.uom) {
      updateTicketSpecification(chargeToCheck).then((resData) => {
        setTicketTotal(resData.ticketTotal);
        getPayrollDetails(ticketData.id).then((payrollDetails) => {
          setPayrollData(payrollDetails);
        })
      });
    }
    setChargeToUpdate(null);
  };

  // EndRegion - UI Handlers

  // Region - Form Setters
  // Setting well other data 
  // const setWellChargeOther = (data) => {
  //   const wellOther = [
  //     {
  //       label: "Other",
  //       type: "textarea",
  //       name: "otherText",
  //       required: false,
  //       value: data.othertext,
  //       disabled: !canUpdateTicket,
  //       size: 12,
  //     }
  //   ]

  //   setWellOtherField(wellOther);
  // };

  const setWellChargeOther = (data) => {
    setWellOtherField([{
      ...wellOtherField[0],
      value:    data.otherText || "",
      disabled: !canUpdateTicket,
    }]);
  };

  // Setting hourly part of the ticket form
  const setTicketHourlyData = (data) => {
    const hourlyFields = [
      {
        label: "Start time",
        type: "timepicker",
        name: "startTime",
        disabled: !canUpdateTicket,
        required: true,
        value: data.startTime,
        size: 3,
        checkDateTime: () => {
          setShowTimeErrorMessage(false);
        },
        onChange: () => hoursFormRef.current.submit(),
      },
      {
        label: "End time",
        type: "timepicker",
        name: "endTime",
        disabled: !canUpdateTicket,
        required: true,
        value: data.endTime,
        checkDateTime: () => {
          setShowTimeErrorMessage(false);
        },
        size: 3,
        onChange: () => hoursFormRef.current.submit(),
      }
    ];

    if (!isCustomer) {
      hourlyFields.push({
        label: "Company Hours",
        type: "number",
        name: "companyHours",
        disabled: !canUpdateTicket,
        required: true,
        value: data.companyHours,
        size: 3,
        onChange: () => hoursFormRef.current.submit(),
      });
      hourlyFields.push({
        label: "Mileage",
        type: "number",
        name: "mileage",
        required: true,
        disabled: !canUpdateTicket,
        value: data.mileage,
        size: 3,
        onChange: () => hoursFormRef.current.submit(),
      });
    }

    hourlyFields.push({
      label: "Description",
      type: "textarea",
      name: "description",
      required: false,
      value: data.description,
      disabled: !canUpdateTicket,
      size: 12,
      onChange: () => hoursFormRef.current.submit(),
    });

    setTicketHourlyFields(hourlyFields);
  };

  // EndRegion - Form Setters


  // Region - Signatures

  // Setting ticket preview and opening signature modal
  const getSignature = (isEmployee) => {
    setIsEmployeeSignature(isEmployee);
    getPreviewTicket(id).then((resData) => {
      setPreviewTicketHtml(resData);
      sethtmlPreviewModalOpened(true);
    });
  };

  const signTicketAction = () => {
    if (!isEmployeeSignature) {
      setSignatureModalOpened(true);
      return;
    }

    getProfile().then((result) => {
      if (result.signature) {
        userSignature(result.signature);
        return;
      }

      setSignatureModalOpened(true);
    });
  };

  // Handle user signature action
  const userSignature = (userSignature) => {
    const data = {
      ticketId: id,
      signature: userSignature,
    };
    setMainLoading(true);
    ticketSign(data).then((resData) => getTicketsData());
    setSignatureModalOpened(false);
    sethtmlPreviewModalOpened(false);
  };

  const sendTicketToCustomer = () => {
    setMainLoading(true);
    sendToCustomer(id).then((res) => getTicketsData());
  };

  // Customer signature
  const addCustomerSignature = (customerSignature, customerPrintedName) => {
    const data = {
      ticketId: id,
      printedName: customerPrintedName,
      signature: customerSignature,
    };
    setMainLoading(true);
    customerTicketSign(data).then((resData) => getTicketsData());
    setSignatureModalOpened(false);
    sethtmlPreviewModalOpened(false);
  };

  // Handle signature save action
  const onSignatureSaved = (signature, printedName) => {
    if (isEmployeeSignature) {
      userSignature(signature);
    } else {
      addCustomerSignature(signature, printedName);
    }
  }

  // Reset all ticket signatures
  const resetTicketSignatures = () => {
    setMainLoading(true);
    resetTicketSign(id).then((resData) => {
      getTicketsData();
      setResetSignaturesModalOpened(false);
    });
  };

  // User Signature modal Actions
  const signatureActions = [
    {
      onClick: signTicketAction,
      color: "primary",
      label: "Sign Ticket",
      variant: "contained"
    },
    {
      onClick: () => sethtmlPreviewModalOpened(false),
      color: "default",
      label: "Cancel",
      variant: "outlined",
    }
  ];

  // Reset signature actions
  const resetSignatureActions = [
    {
      onClick: resetTicketSignatures,
      color: "primary",
      label: "Yes",
      variant: "contained",
    },
    {
      onClick: () => setResetSignaturesModalOpened(false),
      color: "default",
      label: "No",
      variant: "outlined",
    },
  ];

  // EndRegion - Signatures

  const handleDownloadTicket = () => {
    setMainLoading(true);
    downloadTicket(id).then(async (resData) => {
      downloadDoc(resData);
      setMainLoading(false);
    });
  };


  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUploadTicket = () => {
    setUploadTicketModal(true);
  };

  const uploadTicket = () => {
    setMainLoading(true);
    uploadFile(selectedFile, `tickets/upload?ticketId=${id}`, "ticketPdf").then((res) => {
      setUploadTicketModal(false);
      getTicketsData();
    });
  };

  const handleCloseUploadTicketModal = () => {
    setUploadTicketModal(false);
  };

  const uploadActions = [
    {
      onClick: uploadTicket,
      color: "primary",
      label: "Upload Ticket",
      variant: "contained",
    },
    {
      onClick: handleCloseUploadTicketModal,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  // Region - Payrolls

  // Add Payroll Form fields
  const addPayrollFields = [
    {
      label: "Job Title",
      type: "select",
      name: "jobTitle",
      required: true,
      selectOptions: [
        { label: "Tool Pusher", value: "ToolPusher" },
        { label: "Crew Chief", value: "CrewChief" },
        { label: "Derrick Man", value: "DerrickMan" },
        { label: "Floor Hand", value: "FloorHand" },
        { label: "Other", value: "other" },
      ],
      onChange: (event) => {
        setPayrollEntryName("");
        setEmployeeList(
          allEmployees.filter(
            (employee) =>
              employee.jobTitleDisplay === event.target.innerText &&
              !payrollData.some(
                (payrollData) => payrollData.employeeId === employee.id
              )
          )
        );

        if (event.target.textContent === "Other") {
          setShowPayrollEntryName(true);
        } else {
          setShowPayrollEntryName(false);
        }
      },
      value: "",
      size: 12,
    },
    !showPayrollEntryName
      ? {
        label: "Select Employee",
        type: "select",
        name: "employeeId",
        required: false,
        value: "",
        selectOptions: selectEmployee,
        size: 12,
      }
      : "",
    showPayrollEntryName
      ? {
        label: "Name",
        type: "text",
        name: "name",
        required: false,
        value: payrollEntryName,
        size: 12,
      }
      : "",
  ];

  // Payroll Note fields
  const createNoteFields = (data, labor) =>{
    let payrollNoteFields;
      payrollNoteFields = [
        {
          label: "Note content",
          type: "textarea",
          name: "noteContent",
          value: data,
          size: 12,
          disabled : !canUpdateTicket || labor === "Other",
        }
      ];
    setPayrollNoteFields(payrollNoteFields);
  };

   // Handle closing note payroll modal
   const onPayrollNoteModalClosed = () => {
    getPayrollDetails(ticketData.id).then((payrollDetails) => {
      setPayrollData(payrollDetails);
    })
    setNotePayrollModalOpened(false);
  };

  // Handle update note payroll action
  const onPayrollNoteUpdateAction = (row) => {
    setEmployeeId(row.employeeId);
    setNoteTicketId(ticketData.id);
    if(row.employeeNote){
      setNoteId(row.employeeNote.id);
      createNoteFields(row.employeeNote.noteContent, row.labor)
      setIsEditingNote(true);
      setNotePayrollModalOpened(true);
      setIsButtonDisabled(false);
      return;
    }
    createNoteFields("", row.labor)
    setIsEditingNote(false);
    setIsButtonDisabled(true);
    setNotePayrollModalOpened(true);
  };

  // Payroll note form submitted
  const onPayrollNoteFormSubmitted = (data) => {
    let reqBody;
    if (isEditingNote) {
      data.employeeId = employeeId;
      data.Id = noteId;
      updateNote(data).then((resData) =>{
        createNoteFields(data.noteContent)
        setCurrentNoteColor("blue");
        onPayrollNoteModalClosed();
      });
      return;
    }

    reqBody = {
      ticketId: ticketData.id,
      employeeId: employeeId,
      noteContent: data.noteContent,
    };
    createNote(reqBody).then((resData) => {
      onPayrollNoteModalClosed();
    });
  };

  // Note Delete Modal open
  const onNoteDeleteAction = () => {
    setDeleteNoteModalOpened(true);
  };

  // Confirm note delete action
  const onNoteDeleteActionConfirmed = () => {
    deleteNote(noteId);
    setIsButtonDisabled(true);
    setDeleteNoteModalOpened(false);
    onPayrollNoteModalClosed();
  };

  // Cancel note delete action
  const onNoteDeleteModalCancel = () => {
    setDeleteNoteModalOpened(false);
  };

  const onDeleteNoteModalClosed = () => {
    setDeleteNoteModalOpened(false);
  };


  

  // Payroll Edit hours fields
  const createPayrollEditFields = (data) => {

    payrollOriginalRigRef.current = Number(data.rigHours) || 0
    
    let payrollEditFields;
    if (isRoustabout) {
      payrollEditFields = [
        {
          label: "Roustabout Hours",
          type: "number",
          name: "roustaboutHours",
          required: true,
          value: data.roustaboutHours,
          size: 12,
        },
      ];
    } else if (isYard) {
      payrollEditFields = [
        {
          label: "Yard Hours",
          type: "number",
          name: "yardHours",
          required: true,
          value: data.yardHours,
          size: 12,
          step: "any"
        },
      ];
    } else {
      payrollEditFields = [
        {
          label: "Rig Hours",
          type: "number",
          name: "rigHours",
          required: true,
          value: data.rigHours,
          size: 12,
        },
        {
          label: "Travel Hours",
          type: "number",
          name: "travelHours",
          required: true,
          value: data.travelHours,
          size: 12,
        },
        {
          label: "Yard Hours",
          type: "text",
          name: "yardHours",
          required: true,
          value: data.yardHours,
          size: 12,
         
        },
      ];
    }

    setPayrollEditFields(payrollEditFields);
  };

  // Handle closing create payroll modal
  const onPayrollCreateModalClosed = () => {
    setCreatePayrollModalOpened(false);
    setPayrollEntryName("");
  };

  // Handle closing edit payroll moodal
  const onPayrollEditModalClosed = () => {
    setEditPayrollModalOpened(false);
  };

  // Handle submitting form for payroll modals
  const onPayrollModalActionConfirm = () => {
    ref.current.submit();
  };

  // Handle update payroll action
  const onPayrollUpdateAction = (updatedRow) => {
    createPayrollEditFields(updatedRow);
    setEmployeeId(updatedRow.employeeId);
    setPayrollId(updatedRow.id);
    setIsEditingPayroll(true);
    setEditPayrollModalOpened(true);
  };

  
  const selectAllOnFocus = e => e.target.select();


  // Payroll edit form submitted
  const onPayrollEditFormSubmitted = (data) => {
    let reqBody;
    if (isEditingPayroll) {
      data.fieldTicketId = id;
      data.employeeId = employeeId;
      data.id = payrollId;
      updatePayroll(data).then(() => getTicketsData());
      onPayrollEditModalClosed(false);
      return;
    }

    if (data.jobTitle === "other") {
      reqBody = {
        fieldTicketId: id,
        name: data.name,
        jobTitle: data.jobTitle,
      };
    } else {
      reqBody = {
        fieldTicketId: id,
        employeeId: data.employeeId,
        jobTitle: data.jobTitle,
        name: "",
      };
    }
    createNewPayroll(reqBody).then(() => getTicketsData());
    onPayrollCreateModalClosed();
  };

  // Open delete payroll modal
  const onPayrollDeleteAction = (id,name) => {
    setCurrentPayrollIndex(id);
    setCurrentPayrolllName(name);
    setDeletePayrollModalOpened(true);
  };

  // Confirm payroll delete action
  const onPayrollDeleteActionConfirmed = () => {
    deletePayroll(currentPayrollIndex).then(() => getTicketsData());
    setDeletePayrollModalOpened(false);
  };

  // Cancel payroll delete action
  const onPayrollDeleteModalCancel = () => {
    setDeletePayrollModalOpened(false);
  };

  // Payroll create modal actions
  const payrollCreateActions = [
    {
      onClick: onPayrollModalActionConfirm,
      color: "primary",
      label: "Add",
      variant: "contained",
    },
    {
      onClick: onPayrollCreateModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  // Payroll edit modal  actions
  const payrollEditActions = [
    {
      onClick: onPayrollModalActionConfirm,
      color: "primary",
      label: "Save",
      variant: "contained",
    },
    {
      onClick: onPayrollEditModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  // Payroll delete modal actions
  const payrollDeleteActions = [
    {
      onClick: onPayrollDeleteActionConfirmed,
      color: "primary",
      label: "Yes",
      variant: "contained",
    },
    {
      onClick: onPayrollDeleteModalCancel,
      color: "default",
      label: "No",
      variant: "outlined",
    },
  ];

  // Payroll note modal actions
  const payrollNoteActions = [
    {
      onClick: onPayrollModalActionConfirm,
      color: "primary",
      label: "Submit",
      variant: "contained",
      disabled: !canUpdateTicket,
    },
  ];

    // Delete note modal actions
    const deleteNoteActions = [
      {
        onClick: onNoteDeleteActionConfirmed,
        color: "primary",
        label: "Yes",
        variant: "contained",
      },
      {
        onClick: onNoteDeleteModalCancel,
        color: "default",
        label: "No",
        variant: "outlined",
      },
    ];
  // EndRegion - Payrolls
  // Region - Well

  // Well create modal actions

  const addWellFields = [
    {
      label: "Well Record Type",
      type: "select",
      name: "recordType",
      required: true,
      selectOptions: [
        { label: "Number of Rod Subs", value: "NumRodSubs" },
        { label: "Number of Rods", value: "NumRods" },
        { label: "Pump", value: "FirstPump" },
        { label: "Other Pump", value: "SecondPump" },
        { label: "Gas Anchor/Strainer", value: "GasAnchor" },
        { label: "Number of Tubing Subs", value: "NumTubing" },
        { label: "Number of Joints (Tubing or Pipe)", value: "NumJoints" },
      ],
      onChange: (event) => {
        if (event.target.textContent === "Pump") {
          setShowPumpNumber(true);
        } else {
          setShowPumpNumber(false);
        }
        if (event.target.textContent === "Number of Rod Subs") {
          setRodSubsSize(true);
        } else {
          setRodSubsSize(false);
        }
      },
      value: "",
      size: 12,
    },
    ShowPumpNumber
      ? {
        label: "Pump Number",
        type: "number",
        name: "pump_Number",
        required: true,
        value: 0,
        size: 12,
      }
      : "",
     {
        label: "Pulled",
        type: "number",
        name: "pulled",
        required: true,
        value: 0,
        size: 12,
      },
      {
        label: "Ran",
        type: "number",
        name: "ran",
        required: true,
        value: 0,
        size: 12,
      },
      {
        label: "Size",
        type: "number",
        name: "sizeW",
        required: true,
        value: 0,
        size: 12,
      },
      rodSubsSize || ShowPumpNumber ? {
        label: "Size",
        type: "number",
        name: "sizeL",
        required: true,
        value: 0,
        size: 12,
      } : "",
      ShowPumpNumber ? {
        label: "Size",
        type: "number",
        name: "sizeH",
        required: true,
        value: 0,
        size: 12,
      } : "",
  ];

  // Handle closing create well modal
  const onWellCreateModalClosed = () => {
    setCreateWellModalOpened(false);
  }

  // Handle submitting form for well modals
  const onWellModalActionConfirm = () => {
    ref.current.submit()
  };

  // Well form submitted
  const onWellFormSubmitted = (data) => {
    let reqBody;

    reqBody = {
      FieldTicketId : id,
      WellRecordType: data.recordType,
      pump_Number: data.pump_Number,
      pulled: data.pulled,
      ran: data.ran,
      sizeW: data.sizeW,
      sizeL: data.sizeL,
      sizeH: data.sizeH,
    };

    addWellRecord(reqBody).then(() => getTicketsData());
    onWellCreateModalClosed();
  };

  const wellCreateActions = [
    {
      onClick: onWellModalActionConfirm,
      color: "primary",
      label: "Add",
      variant: "contained",
    },
    {
      onClick: onWellCreateModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  // Region - Swab

  // Swab create modal actions

  const addSwabFields = [
    {
        label: "Swab Number",
        type: "number",
        name: "swabNumber",
        required: true,
        value: "",
        size: 12,
      },
     {
        label: "Size",
        type: "number",
        name: "size",
        required: true,
        value: 0,
        size: 12,
      },
      {
        label: "Description",
        type: "text",
        name: "description",
        required: true,
        value: "",
        size: 12,
      },
      {
        label: "Amount",
        type: "text",
        name: "amount",
        required: true,
        value: "",
        size: 12,
      },
  ];

  // Handle closing create swab modal
  const onSwabCreateModalClosed = () => {
    setCreateSwabModalOpened(false);
  }

  // Handle submitting form for well modals
  const onSwabModalActionConfirm = () => {
    ref.current.submit()
  };

  // Swab form submitted
  const onSwabFormSubmitted = (data) => {
    let reqBody;

    reqBody = {
      FieldTicketId : id,
      Number: data.swabNumber,
      Size: data.number,
      Description: data.description,
      Amount: data.amount,
    };

    addSwabCup(reqBody).then(() => getTicketsData());
    onSwabCreateModalClosed();
  };

  const swabCreateActions = [
    {
      onClick: onSwabModalActionConfirm,
      color: "primary",
      label: "Add",
      variant: "contained",
    },
    {
      onClick: onSwabCreateModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  const handleChargeAdded = (charge) => {
    if(charge != ""){
      charge.specialCharge = true;
      updateTicketSpecification(charge).then((resData) => {
        setTicketTotal(resData.ticketTotal);
        getAllSpecialSpecifications(ticketData.id).then((specialSpecs) => {
          setChargesDataWell(specialSpecs);
          if(chargesDataWell.length === 15){
            setDisableAddCharges(true);
          }
        })
      });
    }
  };

  const handleChargeRemoved = (charge) => {
    charge.specialCharge = false;
    charge.quantity = 0;
    updateTicketSpecification(charge).then((resData) => {
      setTicketTotal(resData.ticketTotal);
      getAllSpecialSpecifications(ticketData.id).then((specialSpecs) => {
        setChargesDataWell(specialSpecs);
      })
    });
  };

// guard against undefined and debounce saves:
const saveWellTimers  = useRef({})
function onRbWellChange(idx, field, raw) {
  if (!wellRecord[idx] || !wellRecord[idx].id) return
  const val = raw

  setWellRecord(w => {
    const next = [...w]
    next[idx] = { ...next[idx], [field]: val }
    return next
  })

  const id = wellRecord[idx].id
  clearTimeout(saveWellTimers.current[id])
  saveWellTimers.current[id] = setTimeout(() => {
    updateWellRecord({ ...wellRecord[idx], [field]: val }).catch(console.error)
    // 2) _if_ this was a tubing "ran" edit (tubing indices 11–14), and we have a non-empty value:
    if (field === 'ran' && idx >= 11 && idx <= 18 && val !== '') {
      const pipe = allCharges.find(c => c.charge === 'Pipe Dope');
      if (!pipe) return;

      const payload = {
        ...pipe,
        specialCharge: true,
        quantity: 1,
        rate: pipe.rate,
      };

      updateTicketSpecification(payload)
        .then(() => {
          // refresh the “well” special specs
          return getAllSpecialSpecifications(ticketData.id);
        })
        .then(specs => {
          setChargesDataWell(specs);

          // find the updated Pipe Dope and sync the big table
          const updatedPipe = specs.find(s => s.charge === "Pipe Dope");
          if (updatedPipe) {
            syncPipeDopeInTables(updatedPipe);
          }
        })
        .catch(console.error);
    }
      
  }, 500)
}

  // 1) Add this helper inside the component:
  function syncPipeDopeInTables(updatedPipe) {
    setChargesDataLeft(left =>
      left.map(r =>
        r.charge === "Pipe Dope"
          ? { ...r, rate: updatedPipe.rate, quantity: updatedPipe.quantity }
          : r
      )
    );
    setChargesDataRight(right =>
      right.map(r =>
        r.charge === "Pipe Dope"
          ? { ...r, rate: updatedPipe.rate, quantity: updatedPipe.quantity }
          : r
      )
    );
  }

const saveSwabTimers = useRef({})
function onRbSwabChange(idx, field, raw) {
  if (!swabData[idx] || !swabData[idx].id) return
  const val = raw === '' ? '' : isNaN(Number(raw)) ? raw : parseFloat(raw)

  setSwabData(s => {
    const next = [...s]
    next[idx] = { ...next[idx], [field]: val }
    return next
  })

  const id = swabData[idx].id
  clearTimeout(saveSwabTimers.current[id])
  saveSwabTimers.current[id] = setTimeout(() => {
    updateSwabCup({ ...swabData[idx], [field]: val }).catch(console.error)
  }, 500)
}


  return (
    <Container maxWidth={false}>
      <LoadingComponent loading={mainLoading} />
      <Paper
        elevation={3}
        sx={{ p: 4, mb: 4, backgroundColor: "white", borderRadius: "8px" }}
      >
        <Typography
          variant="h5"
          align="center"
          marginBottom={3}
          color={primaryColor}
          gutterBottom
        >
          Ticket Details
        </Typography>
        <Forms
          fields={ticketBasicInfoFields}
          addParams={canUpdateTicket ? ticketUpdateButton : null}
          ref={basicFormRef}
          onSubmit={onBasicTicketInfoEdited}
        />
        <Divider sx={{ marginTop: 2 }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <div>
            <Button
              type="submit"
              variant="contained"
              color="error"
              style={{ marginRight: "5px" }}
              onClick={() => navigate(`/dashboard/tickets`)}
            >
              Close
            </Button>
            {!isCustomer && !hasUserSignature && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginRight: "5px" }}
                onClick={() => getSignature(true)}
              >
                Sign Ticket
              </Button>
            )}

            {hasUserSignature && !hasCustomerSignature && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginRight: "5px" }}
                onClick={() => getSignature(false)}
              >
                Customer Signature
              </Button>
            )}
            {isAdmin && hasUserSignature && !hasCustomerSignature && (
              <Tooltip title={ticketData && ticketData.isSentToCustomer ? `Last sent on ${formatDateTime(ticketData.sentToCustomerOn)}` : "Send ticket to customer"} arrow placement="top">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginRight: "5px" }}
                onClick={() => sendTicketToCustomer()}
              >
                Send to Customer
              </Button>
            </Tooltip>
            )}
            <Divider sx={{ marginTop: 2 }} />
            <div style={{ marginTop: "10px" }}>
              {hasUserSignature && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "5px" }}
                  onClick={() => handleDownloadTicket()}
                >
                  Download Ticket
                </Button>
              )}
              {(hasUserSignature && (!hasCustomerSignature || isAdmin)) && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "5px" }}
                  onClick={() => handleUploadTicket()}
                >
                  Upload Ticket
                </Button>
              )}
              {hasUserSignature && isAdmin && (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setResetSignaturesModalOpened(true)}
                >
                  Reset Signatures
                </Button>
              )}
            </div>
          </div>

          <Box
            component="span"
            sx={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
          >
            Total: $ {toCurrencyNumber(ticketTotal)}
          </Box>
        </div>
        <ModalComponent
          open={htmlPreviewModalOpened}
          onClose={() => sethtmlPreviewModalOpened(false)}
          title="Sign ticket"
          actions={signatureActions}
          closeOnOutsideClick={false}
        >
          <div class="right-align-checks">
            <label style={{ display: 'block', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={jobComplete === true}
                onChange={() => handleJobCompleteChange(true)}
              />
              {' '}Job Complete
            </label>

            <label style={{ display: 'block', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={jobComplete === false}
                onChange={() => handleJobCompleteChange(false)}
              />
              {' '}Job Incomplete
            </label>
          </div>          
          <div dangerouslySetInnerHTML={{ __html: previewTicketHtml }} />
        </ModalComponent>
        <SignatureModal
          saveAction={onSignatureSaved}
          closeAction={() => setSignatureModalOpened(false)}
          isOpen={signatureModalOpened}
          modalTitle="Set signature"
          showPrintedName={!isEmployeeSignature}
        />
        <ModalComponent
          open={uploadTicketModal}
          onClose={handleCloseUploadTicketModal}
          title={"Upload Signed Ticket"}
          actions={uploadActions}
          closeOnOutsideClick={false}
        >
          <InputLabel
            htmlFor="file-upload"
            sx={{ color: "black", cursor: "pointer" }}
          >
            Choose File
          </InputLabel>
          <Input
            id="file-upload"
            type="file"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {selectedFile && <p>Selected File: {selectedFile.name}</p>}
        </ModalComponent>
        <ModalComponent
          open={resetSignaturesModalOpened}
          onClose={() => setResetSignaturesModalOpened(false)}
          title="Reset Ticket Signatures"
          actions={resetSignatureActions}
          closeOnOutsideClick={false}
        >
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <HighlightOffIcon
              style={{ margin: "auto", fontSize: "58px", color: "red" }}
            />
            <Typography
              style={{
                fontSize: "24px",
                textAlign: "center",
                margin: "15px",
              }}
            >
              Are you sure?
            </Typography>
            <Typography
              style={{
                fontSize: "14px",
                textAlign: "center",
                color: "grey",
              }}
            >
              Are you sure you want to reset all signatures for the ticket? <br />
              The process cannot be undone.
            </Typography>
          </Box>
        </ModalComponent>
      </Paper>
      <Paper
        elevation={3}
        sx={{ p: 4, mb: 4, backgroundColor: "white", borderRadius: "8px" }}
      >
        <Typography
          variant="h5"
          align="center"
          marginBottom={3}
          color={primaryColor}
          gutterBottom
        >
          Time Specification
        </Typography>
        <Forms
          fields={ticketHourlyFields}
          addParams={canUpdateTicket ? ticketUpdateButton : null}
          ref={hoursFormRef}
          onSubmit={onTicketHoursEdited}
        />
        {showTimeErrorMessage && (
          <Typography
            variant="body1"
            align="center"
            sx={{ color: "red", mt: 2, fontWeight: "bold" }}
            gutterBottom
          >
            End time should be after Start time
          </Typography>
        )}
      </Paper>
      <Paper
        elevation={3}
        sx={{ p: 4, mb: 4, backgroundColor: "white", borderRadius: "8px" }}
      >
        <Tabs value={selectedTab} onChange={onTabChange}>
          {!isYard && !isCustomer && <StyledTab label="Charges" />}
          {!isYard && !isCustomer && ticketType==="Well" && <StyledTab label="Well Records" />}
          <StyledTab label="Payroll" />
        </Tabs>
        
        {selectedTab === 0 && !isYard && !isCustomer && (
          <div className="tab-no-title ticket-tables">
            <div className="ticket-table-split ticket-table-split-left">
              <Table>
                <TableHead>
                  <TableRow>
                    {chargesColumn.map((column) => (
                      <TableCell
                        key={column.header}
                        align={column.isTotal ? "right" : ""}
                      >
                        {column.header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chargesDataLeft.map((row, index) => (
                    <TableRow key={row.id} onBlur={() => onChargeRowFocusOut(index, 'left')} onFocus={() => onChargeRowFocusIn(index, 'left')} >
                      <TableCell>{row.charge}</TableCell>
                      <TableCell>
                        <Select
                          value={row.uoM}
                          onChange={(event) => onChargeUpdate(index, event, "uoM", false, 'left')}
                          disabled={!row.allowUoMChange || !canUpdateTicket}
                          style={{ minWidth: "100px" }}
                        >
                          <MenuItem value="EA">EA</MenuItem>
                          <MenuItem value="Hourly">Hourly</MenuItem>
                          <MenuItem value="Daily">Daily</MenuItem>
                          <MenuItem value="Gallon">Gallon</MenuItem>
                        </Select>
                      </TableCell>
                      <TableCell>
                        <TextField
                          inputProps={{
                            inputMode: "text",
                            pattern: "[0-9]+(.[0-9])",
                          }}
                          value={row.rate}
                          disabled={!row.allowRateAdjustment || !canUpdateTicket}
                          onChange={(event) => onChargeUpdate(index, event, "rate", true, 'left')}
                          onFocus={selectAllOnFocus}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]+(.[0-9])",
                          }}
                          value={row.quantity}
                          disabled={row.isReadOnly || !canUpdateTicket}
                          onChange={(event) => onChargeUpdate(index, event, "quantity", true, 'left')}
                          onBlur={() => onQuantityBlur(index, 'left')}
                          onFocus={selectAllOnFocus}
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "right", m: 1, minWidth: "100px" }}>
                        {"$ " + toCurrencyNumber(row.rate * row.quantity)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            <div className="ticket-table-split ticket-table-split-right">
              <Table>
                <TableHead>
                  <TableRow>
                    {chargesColumn.map((column) => (
                      <TableCell
                        key={column.header}
                        align={column.isTotal ? "right" : ""}
                      >
                        {column.header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chargesDataRight.map((row, index) => (
                    <TableRow key={row.id} onBlur={() => onChargeRowFocusOut(index, 'right')} onFocus={() => onChargeRowFocusIn(index, 'right')} >
                      <TableCell >{row.charge}</TableCell>
                      <TableCell>
                        <Select
                          value={row.uoM}
                          onChange={(event) => onChargeUpdate(index, event, "uoM", false, 'right')}
                          disabled={!row.allowUoMChange || !canUpdateTicket}
                          style={{ minWidth: "100px" }}
                        >
                          <MenuItem value="EA">EA</MenuItem>
                          <MenuItem value="Hourly">Hourly</MenuItem>
                          <MenuItem value="Daily">Daily</MenuItem>
                          <MenuItem value="Gallon">Gallon</MenuItem>
                        </Select>
                      </TableCell>
                      <TableCell>
                        <TextField
                          inputProps={{
                            inputMode: "text",
                            pattern: "[0-9]+(.[0-9])",
                          }}
                          value={row.rate}
                          disabled={!row.allowRateAdjustment || !canUpdateTicket}
                          onChange={(event) => onChargeUpdate(index, event, "rate", true, 'right')}
                          onBlur={() => onChargeRowFocusOut(index, 'right')}
                          onFocus={selectAllOnFocus}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]+(.[0-9])",
                          }}
                          value={row.quantity}
                          disabled={row.isReadOnly || !canUpdateTicket}
                          onChange={(event) => onChargeUpdate(index, event, "quantity", true, 'right')}
                          onBlur={() => onChargeRowFocusOut(index, 'right')}
                          onFocus={selectAllOnFocus}
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "right", m: 1, minWidth: "100px" }}>
                        {"$ " + toCurrencyNumber(row.rate * row.quantity)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        )}
        {(selectedTab === 2 || isYard || isCustomer) && (
          <div className="tab-no-title">
            <TableContainer component={Paper}>
              <Table aria-label="payroll table">
                <TableHead>
                  <TableRow>
                    <TableCell>Labor</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Id</TableCell>
                    {isRoustabout && (
                      <TableCell>Roustabout Hours</TableCell>
                    )}
                    
                    {(!isYard && !isRoustabout) && (
                      <TableCell>Rig Hours</TableCell>
                    )}
                    {(!isYard && !isRoustabout) && (
                      <TableCell>Travel Hours</TableCell>
                    )}
                    {(!isRoustabout) && (
                      <TableCell>Yard Hours</TableCell>
                    )}
                    <TableCell style={{ textAlign: "end" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payrollData.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.labor}</TableCell>
                      <TableCell>
                        {row.name.length === 0
                          ? row.employee?.firstName + " " + row.employee?.lastName
                          : row.name}
                      </TableCell>
                      <TableCell>{row.displayEmployeeId}</TableCell>
                      {isRoustabout && (
                        <TableCell>{row.roustaboutHours}</TableCell>
                      )}
                      
                      {(!isYard && !isRoustabout) && (
                        <TableCell>{row.rigHours}</TableCell>
                      )}
                      {(!isYard && !isRoustabout) && (
                        <TableCell>{row.travelHours}</TableCell>
                      )}

                      {(!isRoustabout) && (
                        <TableCell>{row.yardHours}</TableCell>
                      )}
                      <TableCell
                        style={{ textAlign: "end", verticalAlign: "middle" }}
                      >
                        {(isRoustabout || isYard) && canUpdateTicket && (
                          <IconButton
                            onClick={() => onPayrollUpdateAction(row)}
                            aria-label="edit"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {(!isRoustabout && !isYard) && canUpdateTicket && (
                          <IconButton
                            onClick={() => onPayrollUpdateAction(row)}
                            aria-label="edit"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {canUpdateTicket && (
                          <IconButton
                            onClick={() => onPayrollDeleteAction(row.id, row.name.length === 0
                              ? row.employee?.firstName + " " + row.employee?.lastName
                              : row.name)}
                            aria-label="delete"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                        {(
                          <IconButton
                            onClick={() => onPayrollNoteUpdateAction(row)}
                            aria-label="note"
                            style={{color: row.employeeNote
                               ? "blue" : "inherit"}}
                          >
                            <NoteAddIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <ModalComponent
              open={deletePayrollModalOpened}
              onClose={() => setDeletePayrollModalOpened(false)}
              title="Delete Payroll Entry" 
              actions={payrollDeleteActions}
              closeOnOutsideClick={false}
            >
              <Box style={{ display: "flex", flexDirection: "column" }}>
                <HighlightOffIcon
                  style={{ margin: "auto", fontSize: "58px", color: "red" }}
                />
                <Typography
                  style={{
                    fontSize: "24px",
                    textAlign: "center",
                    margin: "15px",
                  }}
                >
                  Are you sure?
                </Typography>
                <Typography
                  style={{
                    fontSize: "14px",
                    textAlign: "center",
                    color: "grey",
                  }}
                >
                  Are you sure you want to delete this payroll entry for {currentPayrollName}? <br />
                  The process cannot be undone.
                </Typography>
              </Box>
            </ModalComponent>
            {canUpdateTicket && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={() => setCreatePayrollModalOpened(true)}
                disabled={
                  isCustomer || (hasUserSignature && hasCustomerSignature)
                }
              >
                Add Payroll Entry
              </Button>
            )}
            <ModalComponent
              open={createPayrollModalOpened}
              onClose={onPayrollCreateModalClosed}
              title={"Add Payroll"}
              actions={payrollCreateActions}
              closeOnOutsideClick={false}
            >
              <Forms
                ref={ref}
                fields={addPayrollFields}
                onSubmit={(data) => onPayrollEditFormSubmitted(data)}
              />
            </ModalComponent>
            <ModalComponent
              open={editPayrollModalOpened}
              onClose={onPayrollEditModalClosed}
              title={"Edit Payroll Hours"}
              actions={payrollEditActions}
              closeOnOutsideClick={false}
            >
              <Forms
                ref={ref}
                fields={payrollEditFields}
                onSubmit={(data) => onPayrollEditFormSubmitted(data)}
              />
            </ModalComponent>
            <ModalComponent
              open={notePayrollModalOpened}
              onClose={onPayrollNoteModalClosed}
              title={"Employee Note"}
              actions={payrollNoteActions}
              closeOnOutsideClick={false}
            >
              <Forms
                ref={ref}
                fields={payrollNoteFields}
                onSubmit={(data) => onPayrollNoteFormSubmitted(data)}
              />
              <Button
                variant="contained"
                size="large"
                style={{ fontWeight: 'bold', marginRight: "20px"}}
                startIcon={<DeleteIcon fontSize="small" style={{ fontWeight: 'bold' }} />}
                onClick={() => onNoteDeleteAction()}
                disabled={isButtonDisabled || !canUpdateTicket}
              >
                DELETE NOTE
              </Button>
            </ModalComponent>
            <ModalComponent
              open={deleteNoteModalOpened}
              onClose={onDeleteNoteModalClosed}
              title={"Are you sure you want to delete this note?"}
              actions={deleteNoteActions}
              closeOnOutsideClick={false}
            >
              <Box style={{ display: "flex", flexDirection: "column" }}>
                <HighlightOffIcon
                  style={{ margin: "auto", fontSize: "58px", color: "red" }}
                />
                <Typography
                  style={{
                    fontSize: "24px",
                    textAlign: "center",
                    margin: "15px",
                  }}
                >
                  Are you sure?
                </Typography>
                <Typography
                  style={{
                    fontSize: "14px",
                    textAlign: "center",
                    color: "grey",
                  }}
                >
                  Are you sure you want to delete this note entry? <br />
                  The process cannot be undone.
                </Typography>
              </Box>
            </ModalComponent>


          </div>
        )}
        {(selectedTab === 1) && (
          <div className="tab-no-title">
            <Container className="my-5 well-record-tables">
                <RBTable
                  bordered
                  size="sm"
                  className="text-center align-middle border-dark"
                >
                  <thead className="RBTable-light border-dark">
                    <tr>
                      <th colSpan={2}>Well Records</th>
                      <th>Pulled</th>
                      <th>Ran</th>
                      <th>Size</th>
                      <th>No.</th>
                      <th>Size</th>
                      <th rowSpan={4}>Swab Cups</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* rod_subs */}
                    {["rod_subs_1", "rod_subs_2", "rod_subs_3", "rod_subs_4"].map(
                      (key, i) => {
                        const rec = wellRecord[i] || {};
                        const swab = swabData[i]      || {}
                        return (
                          <tr key={key}>
                            {i === 0 && (
                              <td
                                rowSpan={4}
                                colSpan={2}
                                className="text-center align-middle fw-semibold"
                              >
                                Number of Rod
                                <br /> Subs
                              </td>
                            )}
                            <td>
                              <Form.Control
                                value={rec.pulled || ""}
                                onChange={e => onRbWellChange(i, "pulled", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            <td>
                              <Form.Control
                                value={rec.ran || ""}
                                onChange={e => onRbWellChange(i, "ran", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            <td className="align-middle fw-bold p-0">
                              <RBTable
                                
                                className="text-center mb-0 align-middle border-dark"
                              >
                                <tbody>
                                  <tr>
                                    <td className="border-0 p-0">
                                      <Form.Control
                                        value={rec.sizeW || ""}
                                        onChange={e =>
                                          onRbWellChange(i, "sizeW", e.target.value)
                                        }
                                        disabled={!canUpdateTicket}
                                      />
                                    </td>
                                    <td className="border-0">×</td>
                                    <td className="border-0 p-0">
                                      <Form.Control
                                        value={rec.sizeL || ""}
                                        onChange={e =>
                                          onRbWellChange(i, "sizeL", e.target.value)
                                        }
                                        disabled={!canUpdateTicket}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </RBTable>
                            </td>
                            <td>
                              <Form.Control
                                value={swab.number || ""}
                                onChange={e => onRbSwabChange(i, "number", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            <td>
                              <Form.Control
                                value={swab.size || ""}
                                onChange={e => onRbSwabChange(i, "size", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            {i === 0 && (
                              <td rowSpan={6}>
                                {/* only one big textarea for Swab Cups */}
                                <Form.Control
                                  as="textarea"
                                  rows={11}
                                  value={swabData[0]?.description || ""}
                                  onChange={e =>
                                    onRbSwabChange(0, "description", e.target.value)
                                  }
                                  disabled={!canUpdateTicket}
                                />
                              </td>
                            )}
                          </tr>
                        );
                      }
                    )}

                    {/* rods */}
                    {["rod_1", "rod_2", "rod_3", "rod_4"].map((key, j) => {
                      const idx = 4 + j;
                      const rec = wellRecord[idx] || {};
                      const swab = swabData[idx]      || {}
                      return (
                        <tr key={key}>
                          {j === 0 && (
                            <td
                              rowSpan={4}
                              colSpan={2}
                              className="text-center align-middle fw-semibold"
                            >
                              Number of Rods
                            </td>
                          )}
                          <td>
                            <Form.Control
                              value={rec.pulled || ""}
                              onChange={e => onRbWellChange(idx, "pulled", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.ran || ""}
                              onChange={e => onRbWellChange(idx, "ran", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.sizeW || ""}
                              onChange={e => onRbWellChange(idx, "sizeW", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          {j <= 1 && (
                            <>
                              <td>
                                <Form.Control
                                  value={swab.number || ""}
                                  onChange={e => onRbSwabChange(idx, "number", e.target.value)}
                                  disabled={!canUpdateTicket}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  value={swab.size || ""}
                                  onChange={e => onRbSwabChange(idx, "size", e.target.value)}
                                  disabled={!canUpdateTicket}
                                />
                              </td>
                            </>
                          )}
                          {j === 2 && (
                            <td
                              colSpan={3}
                              rowSpan={15}
                              className="align-middle text-center"
                            >
                              Charges Section
                            </td>
                          )}
                        </tr>
                      );
                    })}

                    {/* pumps */}
                    {["pump_1", "pump_2"].map((key, k) => {
                      const idx = 8 + k;
                      const rec = wellRecord[idx] || {};
                      return (
                        <tr key={key}>
                          <td
                            className="text-center align-middle fw-semibold"
                            style={{ width: 100 }}
                          >
                            Pump
                            <br />
                            #
                          </td>
                          <td>
                            <Form.Control
                              value={rec.pump_Number || ""}
                              onChange={e =>
                                onRbWellChange(idx, "pump_Number", e.target.value)
                              }
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.pulled || ""}
                              onChange={e => onRbWellChange(idx, "pulled", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.ran || ""}
                              onChange={e => onRbWellChange(idx, "ran", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td className="p-0">
                            <RBTable
                              
                              className={`${styles.firstInnerRBTable} text-center mb-0 align-middle border-dark`}
                            >
                              <tbody>
                                <tr className="border-0">
                                  <td className="border-start-0 p-0">
                                    <Form.Control
                                      className="border-0"
                                      value={rec.sizeW || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeW", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                  <td className="border-0">×</td>
                                  <td className="border-0 p-0">
                                    <Form.Control
                                      className="border-0"
                                      value={rec.sizeL || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeL", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                  <td className="border-0">×</td>
                                  <td className="border-0 p-0">
                                    <Form.Control
                                      className="border-0"
                                      value={rec.sizeH || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeH", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </RBTable>
                          </td>
                        </tr>
                      );
                    })}

                    {/* Gas Anchor/Stainer */}
                    {(() => {
                      const idx = 10;
                      const rec = wellRecord[idx] || {};
                      return (
                        <tr key="gas_anchor">
                          <td colSpan={2} className="text-center align-middle fw-semibold">
                            Gas
                            <br />
                            Anchor/Stainer
                          </td>
                          <td>
                            <Form.Control
                              value={rec.pulled || ""}
                              onChange={e => onRbWellChange(idx, "pulled", e.target.value)}
                              className="pull_gas_stainer_input"
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.ran || ""}
                              onChange={e => onRbWellChange(idx, "ran", e.target.value)}
                              className="pull_gas_stainer_input"
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td className="p-0">
                            <RBTable
                              bordered
                              className={`${styles.secondInnerRBTable} text-center mb-0 align-middle border-dark`}
                            >
                              <tbody>
                                <tr>
                                  <td className="border-start-0">
                                    <Form.Control
                                      value={rec.sizeW || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeW", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                  <td
                                    rowSpan={2}
                                    colSpan={2}
                                    className={styles.column_textarea}
                                  >
                                    <Form.Control
                                      as="textarea"
                                      rows={4}
                                      value={rec.otherText || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "otherText", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                  <td className={`border-end-0 ${styles.column_size_gas_stainer}`}>
                                    <Form.Control
                                      value={rec.sizeL || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeL", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                </tr>
                                <tr className="border-bottom-0">
                                  <td className="border-start-0">size</td>
                                  <td className="border-end-0">
                                    <Form.Control
                                      value={rec.sizeH || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeH", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </RBTable>
                          </td>
                        </tr>
                      );
                    })()}

                    {/* Tubing Subs */}
                    {[1, 2, 3, 4].map((_, j) => {
                      const idx = 11 + j;
                      const rec = wellRecord[idx] || {};
                      return (
                        <tr key={j}>
                          {j === 0 && (
                            <td
                              rowSpan={4}
                              colSpan={2}
                              className="text-center align-middle fw-semibold"
                            >
                              Number of Tubing Subs
                            </td>
                          )}
                          <td>
                            <Form.Control
                              value={rec.pulled || ""}
                              onChange={e => onRbWellChange(idx, "pulled", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td>
                            <Form.Control
                              value={rec.ran || ""}
                              onChange={e => onRbWellChange(idx, "ran", e.target.value)}
                              disabled={!canUpdateTicket}
                            />
                          </td>
                          <td className="align-middle fw-bold p-0">
                            <RBTable
                              
                              className="text-center mb-0 align-middle border-dark"
                            >
                              <tbody>
                                <tr>
                                  <td className="border-start-0 p-0">
                                    <Form.Control
                                      value={rec.sizeW || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeW", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                  <td className="border-0">×</td>
                                  <td className="border-0 p-0">
                                    <Form.Control
                                      value={rec.sizeL || ""}
                                      onChange={e =>
                                        onRbWellChange(idx, "sizeL", e.target.value)
                                      }
                                      disabled={!canUpdateTicket}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </RBTable>
                          </td>
                        </tr>
                      );
                    })}

                    {/* Joint Pipe */}
                    {["joint_pipe_1", "joint_pipe_2", "joint_pipe_3", "joint_pipe_4"].map(
                      (key, j) => {
                        const idx = 15 + j;
                        const rec = wellRecord[idx] || {};
                        return (
                          <tr key={key}>
                            {j === 0 && (
                              <td
                                rowSpan={4}
                                colSpan={2}
                                className="text-center align-middle fw-semibold"
                              >
                                Number of Joint
                                <br />
                                (Tubing or Pipe)
                              </td>
                            )}
                            <td>
                              <Form.Control
                                value={rec.pulled || ""}
                                onChange={e => onRbWellChange(idx, "pulled", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            <td>
                              <Form.Control
                                value={rec.ran || ""}
                                onChange={e => onRbWellChange(idx, "ran", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                            <td>
                              <Form.Control
                                value={rec.sizeW || ""}
                                onChange={e => onRbWellChange(idx, "sizeW", e.target.value)}
                                disabled={!canUpdateTicket}
                              />
                            </td>
                          </tr>
                        );
                      }
                    )}

                    {/* Others */}
                    <tr>
                      <td
                        className="text-center align-middle fw-semibold"
                        style={{ width: 100 }}
                      >
                        Others
                      </td>
                      <td colSpan={4}>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          value={wellOtherField[0].value}
                          disabled={wellOtherField[0].disabled}
                          onChange={e =>
                            setWellOtherField([{
                              ...wellOtherField[0],
                              value: e.target.value
                            }])
                          }
                          onBlur={() =>
                            onWellOtherEdited({ otherText: wellOtherField[0].value })
                          }
                        />
                      </td>
                    </tr>

                    
                  </tbody>
                </RBTable>
            </Container>

          </div>
        )}

                    {/* rig-hours override confirmation */}
<ModalComponent
  open={rigOverrideDialogOpen}
  onClose={() => setRigOverrideDialogOpen(false)}
  title="Override Rig Hours"
  closeOnOutsideClick={false}
  actions={[
    {
      label: 'Confirm',
      color: 'primary',
      variant: 'contained',
      onClick: () => {
        setRigOverrideDialogOpen(false);
        if (rigDraftRef.current) {
          updateTicketSpecification(rigDraftRef.current).then(() => {
            getTicketsData();          // refresh tables, fuel, total
            rigDraftRef.current = null;
          });
        }
      },
    },
    {
      label: 'Cancel',
      color: 'default',
      variant: 'outlined',
      onClick: () => {
        setRigOverrideDialogOpen(false);
        rigDraftRef.current = null;
        getTicketsData();              // revert to original value
      },
    },
  ]}
>
Are you sure you want to change the Rig Hours?
</ModalComponent>
      </Paper>
    </Container>
  );
};
